import React, { ReactElement, Component, useState, useEffect, useContext, Fragment, useMemo, useRef, useCallback } from "react";
import { Row, Col, Button, Card, Form, Collapse, Input, Select, Table, Modal, message, Tooltip } from "antd";
import { injectIntl, FormattedMessage } from "react-intl";
import {
  USER_URL,
  country_code,
  getPhoneAreaCode,
  isEffective,
  guid,
  ROLES_LEVEL,
  format_option_data,
  parse_w_option_data,
  parse_to_kebab,
} from "../user-management/user-util";
import { worker_fetch } from "../../worker/worker-fetch";
import { UserInfoContext } from "../../contexts/user-info";
import { compare_role } from "./permission-operation";
import "./user-profile-edit.less";
import { DeleteOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { FormInstance } from "antd/lib/form";
import { DatacenternameContext } from "../../contexts/datacenter-name";
import { useDeepCompareMemo } from 'use-deep-compare';

const { Option } = Select,
  phone_reg = /^[+-]?\d+$/,
  COL_SPACES = 26,
  G_A = "globalAdmin",
  D_A = "datacenterAdmin",
  C_A = "clusterAdmin",
  C_O = "clusterOwner",
  cluster_admin_arr = [G_A, C_A, C_O],
  W_O = "workspaceOwner",
  N_D = "namespaceDeveloper",
  ALL_C = "All cluster",
  ALL_W = "All workspace",
  ALL_N = "All namespace",
  SUCCESS = "success",
  ERROR = "error";
  // 管理用户能选择的角色，先前端处理，后续角色可变后就需要从后端处理
  // allow_role: any = {
  //   globalAdmin: [G_A, D_A, C_A, C_O, W_O, N_D],
  //   datacenterAdmin: [C_A, C_O, W_O, N_D],
  //   clusterAdmin: [C_A, C_O, W_O, N_D],
  //   clusterOwner: [C_O, W_O, N_D],
  //   workspaceOwner: [W_O, N_D],
  //   namespaceOwner: [N_D],
  // };

export const UserProfileEdit = injectIntl((props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const user_info = useContext(UserInfoContext)[0],
    datacenter_name = useContext(DatacenternameContext)[0],
    [user_id, set_user_id] = useState(""),
    [delete_role_visible, set_delete_role_visible] = useState(false),
    [invite_user_modal_visible, set_invite_user_modal_visible] = useState(false),
    [disable_user_modal_visible, set_disable_user_modal_visible] = useState(false),
    [save_role_modal_visible, set_save_role_modal_visible] = useState(false),
    [disable_c, set_disable_c] = useState(true),
    [disable_w, set_disable_w] = useState(true),
    [disable_n, set_disable_n] = useState(true),
    [loading_r, set_loading_r] = useState(false),
    [loading_c, set_loading_c] = useState(false),
    [loading_w, set_loading_w] = useState(false),
    [loading_n, set_loading_n] = useState(false),
    [init_parse_url, set_init_parse_url] = useState(true),
    [is_update_roles, set_is_update_roles] = useState(false),
    [is_edit, set_is_edit] = useState(false),
    [is_user_exist, set_is_user_exist] = useState(false),
    [is_invite, set_is_invite] = useState(false),
    [can_edit_user, set_can_edit_user] = useState(false),
    [is_save_ing, set_is_save_ing] = useState(false),
    [disable_btn_text, set_disable_btn_text] = useState("Disable"),
    [disable_user_word, set_disable_user_word] = useState(""),
    [url_search, set_url_search] = useState(),
    [init_get_url, set_init_get_url] = useState(""),
    [init_user_data, set_init_user_data]: [any, React.Dispatch<React.SetStateAction<any>>] = useState({}),
    [back_url, set_back_url] = useState(""),
    [back_url_state, set_back_url_state] = useState({}),
    [roles_item, set_roles_item] = useState<any[]>([]),
    [roles_data, set_roles_data]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
    [contact_phone_region, set_contact_phone_region] = useState("TW"),
    [init_contact_phone_number, set_init_contact_phone_number] = useState(),
    [username_readonly, set_username_readonly] = useState(true),
    [subscription_role, set_subscription_role] = useState(),
    [can_rolebinding, set_can_rolebinding] = useState(false),
    [is_modify_basic, set_is_modify_basic] = useState(false),
    [add_role_role_name, set_add_role_role_name] = useState(""),
    [add_role_cluster_name, set_add_role_cluster_name] = useState(""),
    [add_role_workspace_name, set_add_role_workspace_name] = useState(""),
    [add_role_namespace_name, set_add_role_namespace_name] = useState(""),
    [role_item, set_role_item] = useState([]),
    [all_roles_item, set_all_roles_item] = useState([]),
    [role_select, set_role_select] = useState([]),
    [cluster_item, set_cluster_item] = useState([]),
    [cluster_select, set_cluster_select] = useState([]),
    [workspaces_item, set_workspaces_item] = useState([]),
    [workspaces_select, set_workspaces_select] = useState([]),
    [namespaces_item, set_namespaces_item] = useState([]),
    [namespaces_select, set_namespaces_select] = useState([]),
    [deleted_rolebinding, set_deleted_rolebinding] = useState<any>([]),
    [added_rolebinding, set_added_rolebinding] = useState<any>([]),
    [will_delete_role, set_will_delete_role] = useState<any>([]),
    [selected_row, set_selected_row]: [any[], React.Dispatch<React.SetStateAction<any[]>>] = useState<any[]>([]),
    [delete_row_word, set_delete_row_word] = useState(""),
    [new_role, set_new_role] = useState(""),
    [new_cluster, set_new_cluster] = useState(""),
    [new_workspace, set_new_workspace] = useState(""),
    [hight_bgrole, set_hight_bgrole] = useState(""),
    { history } = useMemo(() => props, [props]),
    { formatMessage }: { formatMessage: any } = useDeepCompareMemo(() => props.intl, [props.intl]),
    [form] = Form.useForm(),
    { validateFields, getFieldsError, setFieldsValue, getFieldsValue, getFieldValue } = useMemo((): FormInstance => form, [form]),
    get_fields_value = getFieldsValue(),
    state = history.location.state,
    search = state?.src,
    group_name = state?.gName,
    group_id = state?.gId,
    sub_company = state?.gCompany,
    user_name = state?.username,
    mgmt_status = { ...state?.status, src: "edit" },
    sub_role = state?.subscription_role,
    invalid: boolean = useMemo(
      (): boolean =>
        can_edit_user &&
        (!!getFieldsError().filter(({ errors }) => errors.length).length ||
          Object.values(getFieldsValue(["username", "firstName", "lastName"])).some((value: any): boolean => !value)),
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [getFieldsError(), getFieldsValue(["username", "firstName", "lastName"])]
    ),
    handle_modify_basic = useCallback(() => {
      set_is_modify_basic(true);
    }, []),
    get_values = useCallback(() => {
      // 还缺少权限值部分信息
      const { username, firstName, lastName, country, city, company, alternativeEmail, contactPhone, industry, address, regionCode } = get_fields_value;
      const basic_data = { username, firstName, lastName, country, city, company, alternativeEmail, industry, address };
      const user_info: any = Object.assign(init_user_data, basic_data);
      if (contactPhone) {
        const phone_area_code = getPhoneAreaCode(regionCode).phone_perfix;
        user_info.contactPhone = `+${phone_area_code}${contactPhone}`;
      }
      return user_info;
    }, [get_fields_value, init_user_data]),
    add_rolebindings = useCallback(
      async (userid: string = user_id, key: string | undefined) => {
        if (key !== 'create_user') {
          const datacenter_roles: any = {};
          // const promise_list: any = [];
          added_rolebinding.forEach((item: any) => {
            if (datacenter_roles[item.datacenter]) {
              datacenter_roles[item.datacenter].push(item);
            } else {
              datacenter_roles[item.datacenter] = [item];
            }
          });

          const request_list: any = {
            user: userid,
            roles: [],
          };
          for (let key in datacenter_roles) {
            const dc_role = datacenter_roles[key];
            dc_role.forEach((item: any) => {
              const one_role = {
                datacenter: datacenter_name,
                role: parse_to_kebab(item.roleName),
                cluster: item.cluster,
                workspace: item.workspace,
                namespace: item.namespace,
              };
              request_list.roles.push(one_role);
            });
          }
          return request_list;
        } else {
          return new Promise((resolve: any) => {
            const datacenter_roles: any = {};
            const promise_list: any = [];
            added_rolebinding.forEach((item: any) => {
              if (datacenter_roles[item.datacenter]) {
                datacenter_roles[item.datacenter].push(item);
              } else {
                datacenter_roles[item.datacenter] = [item];
              }
            });

            for (let key in datacenter_roles) {
              const dc_role = datacenter_roles[key];
              const request_list: any = {
                user: userid,
                roles: [],
              };
              dc_role.forEach((item: any) => {
                const one_role = {
                  datacenter: datacenter_name,
                  role: parse_to_kebab(item.roleName),
                  cluster: item.cluster,
                  workspace: item.workspace,
                  namespace: item.namespace,
                };
                request_list.roles.push(one_role);
              });
              promise_list.push(
                new Promise((resolve: any) => {
                  datacenter_name &&
                    worker_fetch({ url: `/v1/datacenter/${key}/adddeleterolebinding`, method: 1, body: request_list, props: { formatMessage, history }, datacenter_name })
                      .then((res: any) => {
                        res && (res.status === 200 || res.status === 201) ? resolve(SUCCESS) : resolve(ERROR);
                      })
                      .catch(() => {
                        resolve(ERROR);
                      });
                })
              );
            }
            Promise.all(promise_list)
              .then((res: any) => {
                if (res.filter((item: any) => item !== SUCCESS).length === 0) {
                  resolve(SUCCESS);
                } else {
                  resolve(ERROR);
                }
              })
              .catch(() => {
                resolve(ERROR);
              });
          });
        }

        // return new Promise((resolve: any) => {
        //   const datacenter_roles: any = {};
        //   const promise_list: any = [];
        //   added_rolebinding.forEach((item: any) => {
        //     if (datacenter_roles[item.datacenter]) {
        //       datacenter_roles[item.datacenter].push(item);
        //     } else {
        //       datacenter_roles[item.datacenter] = [item];
        //     }
        //   });

        //   for (let key in datacenter_roles) {
        //     const dc_role = datacenter_roles[key];
        //     const request_list: any = {
        //       user: userid,
        //       roles: [],
        //     };
        //     dc_role.forEach((item: any) => {
        //       const one_role = {
        //         datacenter: datacenter_name,
        //         role: parse_to_kebab(item.roleName),
        //         cluster: item.cluster,
        //         workspace: item.workspace,
        //         namespace: item.namespace,
        //       };
        //       request_list.roles.push(one_role);
        //     });
        //     promise_list.push(
        //       new Promise((resolve: any) => {
        //         datacenter_name &&
        //           worker_fetch({ url: `/v1/datacenter/${key}/adddeleterolebinding`, method: 1, body: request_list, props: { formatMessage, history }, datacenter_name })
        //             .then(() => {
        //               resolve(SUCCESS);
        //             })
        //             .catch(() => {
        //               resolve(ERROR);
        //             });
        //       })
        //     );
        //   }
        //   Promise.all(promise_list)
        //     .then((res: any) => {
        //       if (res.filter((item: any) => item !== SUCCESS).length === 0) {
        //         resolve(SUCCESS);
        //       } else {
        //         resolve(ERROR);
        //       }
        //     })
        //     .catch(() => {
        //       resolve(ERROR);
        //     });
        // });
        // eslint-disable-next-line
      }, [added_rolebinding, datacenter_name, user_id]),
    del_rolebindings = useCallback(() => {
      const datacenter_roles: any = {};
      // const promise_list: any = [];
      deleted_rolebinding.forEach((item: any) => {
        if (datacenter_roles[item.datacenter]) {
          datacenter_roles[item.datacenter].push(item);
        } else {
          datacenter_roles[item.datacenter] = [item];
        }
      });
      let roles_param: any[] = [];
      for (let dc in datacenter_roles) {
        deleted_rolebinding.forEach((item: any) => {
          if (item.datacenter === dc) {
            roles_param.push({
              key: item.key,
              datacenter: datacenter_name,
              role: parse_to_kebab(item.roleName),
              cluster: item.cluster,
              workspace: item.workspace,
              namespace: item.namespace,
            });
          }
        });
      }
      const request_body = {
        user: user_id,
        roles: roles_param,
      };
      return request_body;
      // 删除角色权限
      // return new Promise((resolve: any) => {
      //   const datacenter_roles: any = {};
      //   const promise_list: any = [];
      //   deleted_rolebinding.forEach((item: any) => {
      //     if (datacenter_roles[item.datacenter]) {
      //       datacenter_roles[item.datacenter].push(item);
      //     } else {
      //       datacenter_roles[item.datacenter] = [item];
      //     }
      //   });
      //   for (let dc in datacenter_roles) {
      //     let roles_param: any[] = [];
      //     deleted_rolebinding.forEach((item: any) => {
      //       if (item.datacenter === dc) {
      //         roles_param.push({
      //           key: item.key,
      //           datacenter: datacenter_name,
      //           role: parse_to_kebab(item.roleName),
      //           cluster: item.cluster,
      //           workspace: item.workspace,
      //           namespace: item.namespace,
      //         });
      //       }
      //     });
      //     const request_body = {
      //       user: user_id,
      //       roles: roles_param,
      //     };
      //     promise_list.push(
      //       new Promise((resolve: any) => {
      //         datacenter_name &&
      //           worker_fetch({ url: `/v1/datacenter/${dc}/adddeleterolebinding`, props: { formatMessage, history }, method: 1, body: request_body, datacenter_name })
      //             .then(() => {
      //               resolve(SUCCESS);
      //             })
      //             .catch(() => {
      //               resolve(ERROR);
      //             });
      //       })
      //     );
      //   }
      //   Promise.all(promise_list)
      //     .then((res: any) => {
      //       if (res.filter((item: any) => item !== SUCCESS).length === 0) {
      //         resolve(SUCCESS);
      //       } else {
      //         resolve(ERROR);
      //       }
      //     })
      //     .catch(() => {
      //       resolve(ERROR);
      //     });
      // });
    }, [datacenter_name, deleted_rolebinding, user_id]),

    handle_edit_user = useCallback(() => {
      return new Promise((resolve: any) => {
        const post_upd_data: any = get_values();
        const username = post_upd_data.username;
        // 以订阅号新增用户方式来到此页面后修改username为已存在的用户，该走此处。
        if (search === "addGroup") {
          const request_body = {
            userName: username,
            subscriptionRole: sub_role,
          };
          datacenter_name &&
            worker_fetch({ url: `/v1/subscriptions/${group_id}/users`, method: 1, body: request_body, props: { formatMessage, history }, datacenter_name }).then(
              () => {
                history.push({ pathname: back_url, state: back_url_state });
              }
            );
          return;
        }
        set_is_save_ing(true);
        const promise_list: any = [];
        if (can_edit_user && is_modify_basic) {
          const post_upd_data: any = get_values();
          const request_url: string = `/v1/users/me?complete=true`;
          promise_list.push(
            new Promise((resolve: any) => {
              datacenter_name &&
                worker_fetch({ url: request_url, method: 2, body: post_upd_data, props: { formatMessage, history }, datacenter_name })
                  .then(() => {
                    resolve(SUCCESS);
                  })
                  .catch(() => {
                    resolve(ERROR);
                  });
            })
          );
        }
        // if (added_rolebinding.length > 0 && datacenter_name) {
        //   promise_list.push(add_rolebindings());
        // }
        // if (deleted_rolebinding.length > 0 && datacenter_name) {
        //   promise_list.push(del_rolebindings());
        // }
        if ((added_rolebinding.length > 0 || deleted_rolebinding.length > 0) && datacenter_name) {
          const newRolebinding = [...added_rolebinding, ...deleted_rolebinding];
          let newRolebinding_arr = [];
          for (const item of newRolebinding) {
            if (newRolebinding_arr.length === 0) {
              newRolebinding_arr.push(item);
              continue;
            }
            for (const one of newRolebinding_arr) {
              if (
                !((item.roleName === one.roleName) &&
                  (item.cluster === one.cluster) &&
                  (item.workspace === one.workspace) &&
                  (item.namespace === one.namespace))
              ) {
                newRolebinding_arr.push(item);
              }
            }
            
          }
          // diaoyongjiekou
          let roles_param: any[] = [];
          newRolebinding_arr.forEach((item: any) => {
            roles_param.push({
              key: item.key,
              datacenter: datacenter_name,
              role: parse_to_kebab(item.roleName),
              cluster: item.cluster,
              workspace: item.workspace,
              namespace: item.namespace,
            })
          })
  
          const request_list = {
              user: user_id,
              roles: roles_param,
            };
          promise_list.push(
            new Promise((resolve: any) => {
              datacenter_name &&
                worker_fetch({ url: `/v1/datacenter/${datacenter_name}/adddeleterolebinding`, method: 1, body: request_list, props: { formatMessage, history }, datacenter_name })
                  .then((res: any) => {
                    res && (res.status === 200 || res.status === 201) ? resolve(SUCCESS) : resolve(ERROR);
                  })
                  .catch(() => {
                    resolve(ERROR);
                  });
            })
          );
          Promise.all(promise_list)
            .then((res: any) => {
              if (res.filter((item: any) => item !== SUCCESS).length === 0) {
                resolve(SUCCESS);
              } else {
                resolve(ERROR);
              }
            })
            .catch(() => {
              resolve(ERROR);
            });
       
        }
        Promise.all(promise_list).then((res: any) => {
          set_is_save_ing(false);
          if (res.filter((item: any) => item !== SUCCESS).length === 0) {
            message.success(formatMessage({ id: "success_save" }));
          }
          history.push({ pathname: back_url, state: back_url_state });
        });
      });

      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
      add_rolebindings,
      // added_rolebinding.length,
      back_url,
      back_url_state,
      can_edit_user,
      datacenter_name,
      del_rolebindings,
      // deleted_rolebinding.length,
      get_values,
      group_id,
      is_modify_basic,
      // formatMessage,
      history,
      search,
      sub_role,
      user_id,
      added_rolebinding,
      deleted_rolebinding
    ]),
    handle_add_user = useCallback(
      async (post_data: any) => {
        set_is_save_ing(true);
        const new_user: any =
          datacenter_name && (await worker_fetch({ url: `/v1/mpusers`, method: 1, body: post_data, props: { formatMessage, history }, datacenter_name }));
        if (new_user.status === 200 || new_user.status === 201) {
          if (is_update_roles) {
            await add_rolebindings(new_user.data.id, 'create_user');
          }
          message.success(formatMessage({ id: "added_successfully" }));
        }
        set_is_save_ing(false);
        history.push({ pathname: back_url, state: back_url_state });
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [add_rolebindings, back_url, back_url_state, datacenter_name, is_update_roles, history]
    ),
    parseSelect = useCallback((data: any) => {
      let children = [];
      for (let i = 0; i < data.length; i++) {
        const { key, value, text } = data[i];
        children.push(
          <Option value={value} key={key}>
            {` ${text}`}
          </Option>
        );
      }
      return children;
    }, []),
    format_country_data = useCallback((data: any) => {
      return data.map((item: any) => {
        return {
          key: item.country_code,
          value: item.country_code,
          text: item.name_en,
        };
      });
    }, []),
    region_options = useMemo(() => parseSelect(format_country_data(country_code)), [format_country_data, parseSelect]),
    // const subscription_columns = [
    //     {
    //         title: formatMessage({ id: 'subscription' }),
    //         dataIndex: 'subscriptionName',
    //         width: 300,
    //     },
    //     {
    //         title: formatMessage({ id: 'id' }),
    //         dataIndex: 'subscriptionId',
    //         width: 500,
    //     },
    //     {
    //         title: formatMessage({ id: 'company' }),
    //         dataIndex: 'company',
    //         width: 200,
    //     },
    //     {
    //         title: formatMessage({ id: 'role' }),
    //         dataIndex: 'subscriptionRole',
    //         width: 200,
    //     },
    // ];
    roles_columns = [
      {
        title: formatMessage({ id: "data_center" }),
        dataIndex: "datacenter",
      },
      {
        title: formatMessage({ id: "cluster" }),
        dataIndex: "cluster",
        render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
      },
      {
        title: formatMessage({ id: "role" }),
        dataIndex: "roleName",
      },
      {
        title: formatMessage({ id: "type" }),
        dataIndex: "type",
      },
      {
        title: formatMessage({ id: "workspace" }),
        dataIndex: "workspaceName",
        render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
      },
      {
        title: formatMessage({ id: "namespace" }),
        dataIndex: "namespace",
        render: (_text: any, _record: any) => <span>{_text || "*"}</span>,
      },
      {
        title: formatMessage({ id: "operation" }),
        render: (text: any, record: any) => {
          return (
            <span>
              <Button className="plain_button" disabled={record.watchOnly} onClick={handle_delete_role.bind(null, text, record)}>
                <DeleteOutlined />
              </Button>
            </span>
          );
        },
      },
    ],
    handle_country_change = useCallback(
      (_value: any) => {
        handle_modify_basic();
      },
      [handle_modify_basic]
    ),
    // handle_datacenter_change = useCallback((value: any, option: any) => {
    //     set_add_role_datacenter_name(option.props.children.trim());
    //     set_datacenter_name(value);
    //     set_new_cluster('');
    //     set_add_role_cluster_name('');
    //     setFieldsValue({ cluster: undefined });
    //     if (!cluster_admin_arr.includes(add_role_role_name)) {
    //         set_add_role_workspace_name('');
    //         set_new_workspace('');
    //         setFieldsValue({ workspace: undefined });
    //         if (add_role_role_name === N_D) {
    //             set_add_role_namespace_name('');
    //             setFieldsValue({ namespace: undefined });
    //         }
    //     }
    // }

    handle_role_change = useCallback(
      (_value: any, option: any) => {
        const role_name = option.props.children.trim();
        set_add_role_role_name(role_name);
        set_new_role(_value);
        if (cluster_admin_arr.includes(role_name)) {
          setFieldsValue({ cluster: undefined, workspace: ALL_W, namespace: ALL_N });
          set_add_role_cluster_name("");
          set_add_role_workspace_name(ALL_W);
          set_add_role_namespace_name(ALL_N);
          set_new_workspace("");
          set_workspaces_item([]);
          set_namespaces_item([]);
          set_disable_c(false);
          set_disable_w(true);
          set_disable_n(true);
        } else if (role_name === D_A) {
          setFieldsValue({ cluster: ALL_C, workspace: ALL_W, namespace: ALL_N });
          set_new_cluster("");
          set_add_role_cluster_name(ALL_C);
          set_disable_c(true);
          set_disable_w(true);
          set_disable_n(true);
        } else if (role_name === W_O) {
          setFieldsValue({ cluster: undefined, workspace: undefined, namespace: ALL_N });
          set_new_cluster("");
          set_add_role_cluster_name("");
          set_new_workspace("");
          set_add_role_namespace_name(ALL_N);
          set_namespaces_item([]);
          set_disable_c(false);
          set_disable_n(true);
          set_disable_w(false);
        } else {
          setFieldsValue({ cluster: undefined, workspace: undefined, namespace: undefined });
          set_new_cluster("");
          set_add_role_cluster_name("");
          set_new_workspace("");
          set_disable_c(false);
          set_disable_n(false);
          set_disable_w(false);
        }
      },
      [setFieldsValue]
    ),
    handle_cluster_change = useCallback(
      (value: any, option: any) => {
        set_add_role_cluster_name(option.props.children.trim());
        set_new_cluster(value);
        if (!cluster_admin_arr.includes(add_role_role_name)) {
          set_add_role_workspace_name("");
          set_new_workspace("");
          setFieldsValue({ workspace: undefined });
          if (add_role_role_name === N_D) {
            set_add_role_namespace_name("");
            setFieldsValue({ namespace: undefined });
          }
        }
      },
      [add_role_role_name, setFieldsValue]
    ),
    handle_workspace_change = useCallback(
      (value: any, option: any) => {
        const { role } = get_fields_value;
        set_add_role_workspace_name(option.props.children.trim());
        if (role !== "namespaceDeveloper") {
          set_new_workspace(value);
          set_add_role_namespace_name(ALL_N);
          setFieldsValue({ namespace: ALL_N });
        } else {
          set_new_workspace(value);
          set_add_role_namespace_name("");
          setFieldsValue({ namespace: undefined });
        }
      },
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [get_fields_value]
    ),
    handle_namespace_change = useCallback((_value: any, option: any) => {
      set_add_role_namespace_name(option.props.children.trim());
    }, []),
    add_role_in_page = useCallback(() => {
      const { workspace } = get_fields_value;
      const new_role: any = {
        key: guid(),
        datacenter: datacenter_name,
        cluster: add_role_cluster_name,
        roleName: add_role_role_name,
        workspace: workspace === ALL_W ? "" : workspace,
        workspaceName: workspace === ALL_W ? "" : add_role_workspace_name,
        namespace: add_role_namespace_name === ALL_N ? "" : add_role_namespace_name,
        type: "rolebinding",
      };
      // const new_role_for_compare = JSON.parse(JSON.stringify(new_role));
      // for (let key in new_role_for_compare) {
      //     if (!new_role_for_compare[key]) {
      //         delete new_role_for_compare[key];
      //     }
      // }
      // console.log(roles_data);
      let is_role_exist: boolean = false;
      roles_data.forEach((item: any) => {
        if (
          item.roleName === new_role.roleName &&
          item.cluster === new_role.cluster &&
          item.workspace === new_role.workspace &&
          item.namespace === new_role.namespace
        ) {
          is_role_exist = true;
        }
      });
      if (is_role_exist) {
        message.warning(formatMessage({ id: "resources_permission_exist" }));
        return;
      }

      let is_deleted = false;
      const deletes: any = [...deleted_rolebinding];
      for (let i = 0; i < deletes.length; i++) {
        const item = deletes[i];
        if (compare_role(item, new_role)) {
          deletes.splice(i, 1);
          is_deleted = true;
          break;
        }
      }
      if (!is_deleted) {
        set_added_rolebinding([...added_rolebinding, new_role]);
      } else {
        set_deleted_rolebinding(deletes);
      }
      const new_roles: any = [...roles_data, new_role];
      set_roles_data(new_roles);

      set_is_update_roles(true);
      setFieldsValue({ role: undefined, cluster: undefined, workspace: undefined, namespace: undefined });
      set_add_role_role_name("");
      set_add_role_cluster_name("");
      set_add_role_workspace_name("");
      set_add_role_namespace_name("");
      set_disable_c(true);
      set_disable_w(true);
      set_disable_n(true);
      // set_role_item([]);
      set_cluster_item([]);
      set_workspaces_item([]);
      set_namespaces_item([]);
      set_new_role("");
      set_new_cluster('');
      set_new_workspace("");
    }, [
      add_role_cluster_name,
      add_role_namespace_name,
      add_role_role_name,
      add_role_workspace_name,
      added_rolebinding,
      datacenter_name,
      deleted_rolebinding,
      formatMessage,
      get_fields_value,
      roles_data,
      setFieldsValue,
    ]),
    handle_del_limit = useCallback(() => {
      set_will_delete_role([...selected_row]);
      set_delete_row_word(formatMessage({ id: "delete_roles" }));
      set_delete_role_visible(true);
    }, [formatMessage, selected_row]),
    delete_role_in_page = useCallback(() => {
      const group_data_new = roles_data.filter((item: any) => {
        let flag = true;
        will_delete_role.forEach((one: any) => {
          if (one?.key === item.key) {
            flag = false;
          }
        });
        return flag;
      });
      set_roles_data(group_data_new);
      // 删除rolebinding时判断是不是此次新增的，如果是，在新增数组中删除之
      const adds: any = [...added_rolebinding];
      const truely_deletes: any = [];
      will_delete_role.forEach((one: any) => {
        let is_added = false;
        for (let i = 0; i < adds.length; i++) {
          const add_one = adds[i];
          if (compare_role(add_one, one)) {
            adds.splice(i, 1);
            is_added = true;
            break;
          }
        }
        if (!is_added) {
          truely_deletes.push(one);
        }
      });
      if (adds.length !== added_rolebinding) {
        set_added_rolebinding(adds);
      }
      set_deleted_rolebinding([...deleted_rolebinding, ...truely_deletes]);
      set_is_update_roles(true);
      set_delete_role_visible(false);
    }, [added_rolebinding, deleted_rolebinding, roles_data, will_delete_role]),
    handleDeleteOk = useCallback(() => {
      delete_role_in_page();
    }, [delete_role_in_page]),
    disable_add_role_button = useMemo(() => {
      const { role, cluster, workspace, namespace } = get_fields_value;
      if (isEffective(role) && isEffective(cluster)) {
        if (cluster_admin_arr.includes(add_role_role_name)) {
          return false;
        } else if (add_role_role_name === W_O) {
          if (isEffective(workspace)) {
            return false;
          }
        } else if (add_role_role_name === N_D) {
          if (isEffective(workspace) && isEffective(namespace)) {
            return false;
          }
        }
      }
      if (isEffective(role) && add_role_role_name === D_A) {
        return false;
      }
      return true;
    }, [add_role_role_name, get_fields_value]),
    disable_del_role_button = useMemo(() => {
      let flag = false;
      if (selected_row.length === 0) {
        flag = true;
      }
      selected_row.forEach((item: any) => {
        if (item?.type === "subscription") {
          flag = true;
        }
      });
      return flag;
    }, [selected_row]),
    handle_phone_country_change = useCallback(
      (value: any) => {
        set_contact_phone_region(value);
        handle_modify_basic();
      },
      [handle_modify_basic]
    ),
    // handle_check_phone = useCallback((_rule: any, value: any, callback: any) => {
    //     if (phone_reg.test(value)) {
    //         worker_fetch({ url: `/v1/validators/phones/${value}?regionCode=${contact_phone_region}`, props , datacenter_name}).then((res: any) => {
    //             if (res.data && res.data.valid) {
    //                 callback();
    //             } else {
    //                 callback('Phone number for this region is invalid');
    //             }
    //         }).catch(() => {
    //             callback();
    //         });
    //     } else {
    //         if (value) {
    //             callback('Incorrect phone number');
    //         } else {
    //             callback();
    //         }
    //     }
    // }

    save_profile = useCallback(() => {
      if (is_edit) {
        handle_edit_user();
      } else {
        const post_data: any = get_values();
        if (url_search === "addGroup") {
          post_data.userSubscriptions = [
            {
              subscriptionName: group_name,
              subscriptionRole: subscription_role,
            },
          ];
        }
        handle_add_user(post_data);
      }
    }, [get_values, group_name, handle_add_user, handle_edit_user, is_edit, subscription_role, url_search]),
    handle_add_profile = useCallback(async () => {
      try {
        const value: any = await validateFields();
        if (value) {
          const is_role_ready = !disable_add_role_button;
          if (is_role_ready) {
            set_save_role_modal_visible(true);
          } else {
            save_profile();
          }
        }
      } catch (err) {
        console.error(err);
      }
    }, [disable_add_role_button, save_profile, validateFields]),
    handle_cancel = useCallback(() => {
      history.push({ pathname: back_url, state: back_url_state });
    }, [back_url, back_url_state, history]),
    handle_delete_role = useCallback(
      (_text: any, record: any) => {
        set_will_delete_role([record]);
        set_delete_row_word(formatMessage({ id: "delete_role" }));
        set_delete_role_visible(true);
      },
      [formatMessage]
    ),
    handleDeleteCancel = useCallback(() => {
      set_delete_role_visible(false);
      set_will_delete_role([]);
    }, []),
    handle_disable_user = useCallback(async () => {
      const username = getFieldValue("username");
      datacenter_name && (await worker_fetch({ url: `/v1/mpusers/${username}?cockroach=true`, method: 3, props: { formatMessage, history }, datacenter_name }));
      if (disable_btn_text === "Enable") {
        set_disable_user_word("Are you sure you want to disable this user?");
        set_disable_btn_text("Disable");
      } else {
        set_disable_user_word("Are you sure you want to enable this user?");
        set_disable_btn_text("Enable");
      }
      set_disable_user_modal_visible(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [datacenter_name, disable_btn_text, getFieldValue, history]),
    handle_disable_cancel = useCallback(() => {
      set_disable_user_modal_visible(false);
    }, []),
    handle_goto_save_role = useCallback(() => {
      set_save_role_modal_visible(false);
    }, []),
    handle_giveup_save_role = useCallback(() => {
      set_save_role_modal_visible(false);
      save_profile();
    }, [save_profile]),
    handle_invite_user_ok = useCallback(() => {
      set_is_user_exist(true);
      set_invite_user_modal_visible(false);
    }, []),
    handle_invite_user_cancel = useCallback(() => {
      set_invite_user_modal_visible(false);
    }, []),
    handle_username_blur = useCallback(async () => {
      if (!is_edit) {
        const username = getFieldValue("username");
        if (!isEffective(username)) {
          return;
        }
        const result: any =
          datacenter_name && (await worker_fetch({ url: `/v4.0/validators/users/${username}`, props: { formatMessage, history }, datacenter_name }));
        if (result.status === 200 && result.data.existing === true) {
          set_invite_user_modal_visible(true);
        }
      }
      // eslint-disable-next-line
    }, [datacenter_name, getFieldValue, is_edit, history]),
    contactPhonePrefixSelector = (
      <Select showSearch placeholder="Select a country or region" optionFilterProp="children" onChange={handle_phone_country_change} style={{ width: "150px" }}>
        {region_options}
      </Select>
    ),
    rowSelection = useRef({
      onSelect: (_record: any, _selected: any, selectedRows: any) => {
        set_selected_row(selectedRows);
      },
      onSelectAll: (_selected: any, selectedRows: any) => {
        set_selected_row(selectedRows);
      },
    });

  useEffect(() => {
    // 根据路径参数判断打开它的页面是哪一个 区别处理
    if (init_parse_url) {
      set_init_parse_url(false);
      set_url_search(search);
      switch (search) {
        case "add":
          set_back_url(USER_URL.management);
          set_username_readonly(false);
          set_back_url_state({ ...mgmt_status });
          break;
        case "edit":
          set_back_url(USER_URL.management);
          set_init_get_url(`/v1/mpusers/${user_name}`);
          set_back_url_state({ ...mgmt_status });
          set_is_edit(true);
          break;
        case "editProfile":
          set_back_url(USER_URL.myProfile);
          set_init_get_url(`/v1/users/me?complete=true`);
          set_is_edit(true);
          break;
        case "addGroup":
          set_back_url(USER_URL.groupsDetail);
          set_back_url_state({ gName: group_name, gId: group_id });
          set_username_readonly(false);
          set_subscription_role(sub_role);
          setFieldsValue({ username: user_name });
          // 将订阅号信息带过来展示
          // set_subscription_data([{
          //     subscriptionId: group_id,
          //     subscriptionName: group_name,
          //     subscriptionRole: sub_role,
          //     company: sub_company,
          //     key: group_id,
          // }]);

          break;
      }
    }
    // eslint-disable-next-line
  }, [
    set_init_get_url,
    set_url_search,
    set_back_url,
    init_parse_url,
    set_init_parse_url,
    setFieldsValue,
    search,
    group_id,
    group_name,
    user_name,
    // mgmt_status,
    formatMessage,
    sub_role,
    sub_company,
  ]);

  useEffect(() => {
    if (isEffective(user_info.role) && !ROLES_LEVEL[1].includes(user_info.role)) {
      set_can_rolebinding(true);
    }
  }, [user_info]);
  useEffect(() => {
    if (isEffective(init_get_url) && datacenter_name) {
      worker_fetch({ url: init_get_url, func: set_init_user_data, props: { formatMessage, history }, datacenter_name });
    }
    // eslint-disable-next-line
  }, [init_get_url, datacenter_name, history]);

  useEffect(() => {
    if (isEffective(init_user_data)) {
      set_user_id(init_user_data.id);
      setFieldsValue({
        username: init_user_data.userName,
        firstName: init_user_data.firstName,
        lastName: init_user_data.lastName,
        alternativeEmail: init_user_data.alternativeEmail,
        industry: init_user_data.industry,
        country: init_user_data.country,
        city: init_user_data.city,
        company: init_user_data.company,
        address: init_user_data.address,
        userId: init_user_data.id,
      });
      if (phone_reg.test(init_user_data.contactPhone)) {
        set_init_contact_phone_number(init_user_data.contactPhone);
      }
      if (typeof init_user_data.status === "string" && init_user_data.status.toLowerCase() === "disabled") {
        set_disable_user_word("Are you sure you want to enable this user?");
        set_disable_btn_text("Enable");
      } else {
        set_disable_user_word("Are you sure you want to disable this user?");
        set_disable_btn_text("Disable");
      }
      // if (Array.isArray(init_user_data.userSubscriptions) && init_user_data.userSubscriptions.length > 0) {
      //     set_subscription_data(init_user_data.userSubscriptions.map((item: any, index: number) => {
      //         return Object.assign(item, { key: index });
      //     }));
      // }
    }
  }, [init_user_data, setFieldsValue]);

  // 获取用户权限列表
  useEffect(() => {
    if (isEffective(user_id) && datacenter_name) {
      worker_fetch({ url: `/v1/datacentercode`, props: { formatMessage, history }, datacenter_name }).then((res: any) => {
        if (res.status === 200) {
          const datacenterCode = res.data.datacenterCode;
          if (isEffective(datacenterCode)) {
            worker_fetch({ url: `/v1/datacenter/${datacenterCode}/resourceinfo?userid=${user_id}`, props: { formatMessage, history }, datacenter_name }).then(
              (res: any) => {
                if (res.status === 200) {
                  const roles: any = res.data.roles;
                  if (Array.isArray(roles) && roles.length > 0) {
                    for (let role of roles) {
                      if (!role.workspace) {
                        role.workspace = "";
                      }
                      if (!role.namespace) {
                        role.namespace = "";
                      }
                    }
                    set_roles_item(roles);
                  }
                }
              }
            );
          }
        }
      });
    }
    // eslint-disable-next-line
  }, [ user_id, set_roles_item, datacenter_name, history]);

  useEffect(() => {
    if (isEffective(user_info) && isEffective(search)) {
      const myID = user_info.id;
      if (search === "add" || search === "addGroup") {
        set_can_edit_user(true);
      } else {
        if (isEffective(user_id) && user_id === myID) {
          set_can_edit_user(true);
        }
      }
    }
  }, [user_id, user_info, search]);

  useEffect(() => {
    const for_workspace_name: any = {};
    roles_item.forEach((item: any) => {
      if (!for_workspace_name[item.datacenter]) {
        for_workspace_name[item.datacenter] = {};
        if (item.cluster && item.workspace) {
          for_workspace_name[item.datacenter][item.cluster] = [{ id: item.workspace }];
        }
      } else if (item.cluster && item.workspace) {
        if (!for_workspace_name[item.datacenter][item.cluster]) {
          for_workspace_name[item.datacenter][item.cluster] = [{ id: item.workspace }];
        } else {
          for_workspace_name[item.datacenter][item.cluster].push({ id: item.workspace });
        }
      }
    });

    const promise_list = [];
    for (let dc_key in for_workspace_name) {
      const dc = for_workspace_name[dc_key];
      for (let c_key in dc) {
        const p_one = new Promise((resolve: any) => {
          datacenter_name &&
            worker_fetch({ url: `/v1/datacenter/${dc_key}/cluster/${c_key}/workspacenames`, props: { formatMessage, history }, datacenter_name }).then(
              (res: any) => {
                if (res.status === 200) {
                  const w_names = res.data.items;
                  for (let item of w_names) {
                    for (let one_item of roles_item) {
                      const role_item_any: any = one_item;
                      if (role_item_any.workspace && item.id === role_item_any.workspace) {
                        role_item_any.workspaceName = item.name;
                      }
                    }
                  }
                }
                resolve();
              }
            );
        });
        promise_list.push(p_one);
      }
    }

    Promise.all(promise_list).then(() => {
      const roles_list: any = roles_item.map((item: any) => {
        return Object.assign(item, { key: guid() });
      });
      set_roles_data(roles_list);
    });
    // eslint-disable-next-line
  }, [roles_item, set_roles_data, datacenter_name, history]);

  // 获取role的可选项
  useEffect(() => {
    if (can_rolebinding && datacenter_name) {
      //         worker_fetch({ url: `/v1/datacenter/${datacenter_name}/roles`, props: { formatMessage, history }, datacenter_name })
      //             .then((res: any) => {
      //                 if (res.data.items) {
      //                     const role_list: any = [...res.data.items];
      //                     role_list.forEach((item: any) => {
      //                         item.metadata.name = parse_to_camel(item.metadata.name);
      //                     });
      //                     // console.log(role_list)
      //                     set_all_roles_item(role_list);
      //                 }
      //             });
      const role_list = ["datacenterAdmin", "clusterAdmin", "clusterOwner", "workspaceOwner", "namespaceDeveloper"];
      set_all_roles_item((role_list as unknown) as []);
    }
  }, [datacenter_name, set_all_roles_item, can_rolebinding, history]);

  // // 角色选择框需要根据/getrole这个api返回值来确定显示什么
  // useEffect(() => {
  //   //此时根据当前所选的资源（dc、cluster、ws）确定此时role选项中应该显示啥
  //   if (isEffective(all_roles_item) && isEffective(user_info) && datacenter_name) {
  //     const my_roles = user_info.roles || [];
  //     let allow_roles = [];
  //     let my_allow_roles = [];

  //     for (let one of my_roles) {
  //       const dc = one.datacenter;
  //       const cluster = one.cluster;
  //       const role_name = one.roleName;
  //       if (role_name === G_A) {
  //         if (dc === datacenter_name) {
  //           my_allow_roles.push(one);
  //         }
  //       } else if (role_name === D_A) {
  //         if (dc === datacenter_name) {
  //           my_allow_roles.push(one);
  //         }
  //       } else if (role_name === C_A) {
  //         if (dc === datacenter_name && cluster === new_cluster) {
  //           my_allow_roles.push(one);
  //         }
  //       } else if (role_name === C_O) {
  //         if (dc === datacenter_name && cluster === new_cluster) {
  //           my_allow_roles.push(one);
  //         }
  //       } else if (role_name === W_O) {
  //         if (dc === datacenter_name && cluster === new_cluster) {
  //           my_allow_roles.push(one);
  //         }
  //       }
  //     }

  //     // 如果是dcAdmin直接放行。因为第一个初始账号不会有roles字段
  //     if (user_info.is_globaladmin) {
  //       allow_roles = allow_role.globalAdmin;
  //     } else if (user_info.is_datacenteradmin) {
  //       allow_roles = allow_role.datacenterAdmin;
  //     } else {
  //       // 其中有cluster1的C_A和cluster1下ws1的W_O时按照C_A来 （资源权限包含时取最大）
  //       if (
  //         my_allow_roles.filter((item: any) => {
  //           return item.roleName === G_A;
  //         }).length > 0
  //       ) {
  //         allow_roles = allow_role.globalAdmin;
  //       } else if (
  //         my_allow_roles.filter((item: any) => {
  //           return item.roleName === D_A;
  //         }).length > 0
  //       ) {
  //         allow_roles = allow_role.datacenterAdmin;
  //       } else if (
  //         my_allow_roles.filter((item: any) => {
  //           return item.roleName === C_A;
  //         }).length > 0
  //       ) {
  //         allow_roles = allow_role.clusterAdmin;
  //       } else if (
  //         my_allow_roles.filter((item: any) => {
  //           return item.roleName === C_O;
  //         }).length > 0
  //       ) {
  //         allow_roles = allow_role.clusterOwner;
  //       } else if (
  //         my_allow_roles.filter((item: any) => {
  //           return item.roleName === W_O;
  //         }).length > 0
  //       ) {
  //         allow_roles = allow_role.workspaceOwner;
  //       }
  //     }

  //     if (allow_roles?.length > 0) {
  //       const all_roles_clone = JSON.parse(JSON.stringify(all_roles_item));
  //       for (let i = 0; i < all_roles_clone.length; i++) {
  //         // if (!allow_roles.includes(all_roles_clone[i].metadata.name)) {
  //         if (!allow_roles.includes(all_roles_clone[i])) {
  //           all_roles_clone.splice(i, 1);
  //           --i;
  //         }
  //       }
  //       set_role_item(all_roles_clone);
  //     } else {
  //       set_role_item([]);
  //     }
  //   }
  // }, [all_roles_item, datacenter_name, new_cluster, user_info]);

  useEffect(() => {
    if (isEffective(all_roles_item) && isEffective(user_info) && datacenter_name) {
      let allow_roles: string[] = [];
      switch (hight_bgrole) {
        case "globalAdmin": allow_roles = ["globalAdmin","datacenterAdmin","clusterAdmin","clusterOwner","workspaceOwner","namespaceDeveloper"];
        break;
        case "datacenterAdmin": allow_roles = ["datacenterAdmin","clusterAdmin","clusterOwner","workspaceOwner","namespaceDeveloper"]
        break;
        case "clusterAdmin": allow_roles = ["clusterAdmin","clusterOwner","workspaceOwner","namespaceDeveloper"]
        break;
        case "clusterOwner": allow_roles = ["clusterOwner","workspaceOwner","namespaceDeveloper"]
        break;
        case "workspaceOwner": allow_roles = ["workspaceOwner","namespaceDeveloper"]
        break;
        case "namespaceDeveloper": allow_roles = ["namespaceDeveloper"]
        break;
        default:
        break;
      }
      set_role_item(allow_roles as any);
    } else {
      set_role_item([])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[hight_bgrole])

  useEffect(() => {
    set_role_select(format_option_data(role_item));
  }, [role_item]);

  // 获取当前用户可绑定的最高权限
  useEffect(() => {
    if(user_info.userName) {
      (async () => {
        set_loading_r(true);
        await worker_fetch({ url: `/v1/datacenter/${datacenter_name}/getrole`, props: { formatMessage, history }, datacenter_name }).then((res: any) => {
          if (res && res.data) {
            set_hight_bgrole(res.data.highBdRole);
          }
        });
        set_loading_r(false);
      })()
    }
    // eslint-disable-next-line
  },[user_info.userName, datacenter_name])

  // 获取cluster的可选项
  useEffect(() => {
    if (datacenter_name && user_info.userName && new_role) {
      (async () => {
          set_loading_c(true);
          new_role !== "datacenterAdmin" && await worker_fetch({
          url: `/v1/datacenter/${datacenter_name}/getroleclusters?bindrole=${new_role}`,
          // url: `/v1/datacenter/${datacenter_name}/clusternames`,
          func: set_cluster_item,
          props: { history, formatMessage, warning: false },
          datacenter_name,
        });
        set_loading_c(false);
      })()
    }
    // eslint-disable-next-line
  }, [set_cluster_item, datacenter_name, user_info.userName, history, new_role]);

  // useEffect(() => {
  //   set_cluster_select(parse_w_option_data(cluster_item));
  //   if (cluster_item[0]) {
  //     setFieldsValue({ cluster: (cluster_item[0] as any).name });
  //     set_new_cluster((cluster_item[0] as any).name);
  //     set_add_role_cluster_name((cluster_item[0] as any).name);
  //   }
  // }, [cluster_item, setFieldsValue]);

    useEffect(() => {
    set_cluster_select(parse_w_option_data(cluster_item));
  //   if (cluster_item[0]) {
  //     setFieldsValue({ cluster: (cluster_item[0] as any).name });
  //     set_new_cluster((cluster_item[0] as any).name);
  //     set_add_role_cluster_name((cluster_item[0] as any).name);
  //   }
  }, [cluster_item]);

  // 获取workspaces的可选项
  useEffect(() => {
    if (!cluster_admin_arr.includes(new_role) && datacenter_name && isEffective(new_cluster)) {
      (async () => {
        set_loading_w(true);
        await worker_fetch({
          // url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspacenames`,
          url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/getroleworkspaces?bindrole=${new_role}`,
          func: set_workspaces_item,
          props: { history, formatMessage, warning: false },
          datacenter_name,
        });
        set_loading_w(false);
      })()
    }
    // eslint-disable-next-line
  }, [datacenter_name, set_workspaces_item, new_cluster, new_role, history]);
  useEffect(() => {
    set_workspaces_select(parse_w_option_data(workspaces_item));
  }, [workspaces_item]);

  // 获取namespaces的可选项
  useEffect(() => {
    if (datacenter_name && isEffective(new_cluster) && isEffective(new_workspace)) {
      (async () => {
        set_loading_n(true);
        new_role === "namespaceDeveloper" && worker_fetch({
          // url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspace/${new_workspace}/namespacenames`,
          url: `/v1/datacenter/${datacenter_name}/cluster/${new_cluster}/workspace/${new_workspace}/getrolenamespaces?bindrole=${new_role}`,
          func: set_namespaces_item,
          props: { history, formatMessage, warning: false },
          datacenter_name,
        });
        set_loading_n(false);
      })()

    }
    // eslint-disable-next-line
  }, [set_namespaces_item, datacenter_name, new_cluster, new_workspace, new_role, history]);

  useEffect(() => {
    set_namespaces_select(parse_w_option_data(namespaces_item));
  }, [namespaces_item]);

  useEffect(() => {
    if (phone_reg.test(init_contact_phone_number || "") && datacenter_name) {
      worker_fetch({ url: `/v4.0/validators/phones/${init_contact_phone_number}`, props: { formatMessage, history }, datacenter_name }).then((res: any) => {
        if (res.status === 200 && res.data && res.data.valid) {
          set_contact_phone_region(res.data.regionCode);
          setFieldsValue({ contactPhone: res.data.nationalNumber });
        }
      });
    }
    // eslint-disable-next-line
  }, [init_contact_phone_number, setFieldsValue, datacenter_name, history]);

  useEffect(() => {
    // validateFields(['contactPhone'], { force: true });
    validateFields(["contactPhone"]);
  }, [contact_phone_region, validateFields]);

  useEffect(() => {
    if (is_user_exist && datacenter_name) {
      const username = getFieldValue("username");
      worker_fetch({ url: `/v1/mpusers/${username}`, props: { formatMessage, history }, datacenter_name }).then((res: any) => {
        if (res.status === 200 && res.data) {
          set_user_id(res.data.id);
          setFieldsValue({
            userId: res.data.id,
          });
          set_username_readonly(true);
          set_is_edit(true);
          set_can_edit_user(false);
          set_is_invite(true);
        }
      });
    }
    // eslint-disable-next-line
  }, [is_user_exist, setFieldsValue, getFieldValue, datacenter_name, history]);

  return (
    <Fragment>
      <Row className="p-20">
        <Col sm={24} className="card_title management-label-line font-size-16">
          <FormattedMessage id="user_info" />
          <Tooltip placement="rightBottom" title={<FormattedMessage id="user_info_sub" />}><QuestionCircleOutlined className="autoscale_help" /></Tooltip>
        </Col>
        {/* <Col sm={24} className="management-select-area w-100">
          <FormattedMessage id="user_info_sub" />
        </Col> */}
      </Row>
      <Card hoverable className="profile-card">
        <Col sm={24} className="mt-10">
          <Form form={form}>
            <Collapse defaultActiveKey={["1", "2", "3"]}>
              <Collapse.Panel
                key="1"
                header={
                  <span className="font-w-6">
                    <FormattedMessage id="user_base_info" />
                  </span>
                }
                className="user_edit_collapse"
              >
                <Row gutter={COL_SPACES}>
                  <Col span={is_invite ? 12 : 8}>
                    <Form.Item
                      name="username"
                      label={formatMessage({ id: "username_email" })}
                      labelAlign="left"
                      labelCol={{ sm: 24 }}
                      rules={[{ required: true, message: "This field is required" }]}
                      validateTrigger={["onChange", "onBlur"]}
                    >
                      <Input type="email" readOnly={username_readonly} onBlur={handle_username_blur} autoComplete="off" onChange={handle_modify_basic} />
                    </Form.Item>
                  </Col>
                  {!is_invite && [
                    <Col span={8} key="firstName">
                      <Form.Item
                        name="firstName"
                        label={formatMessage({ id: "first_name" })}
                        labelAlign="left"
                        labelCol={{ sm: 24 }}
                        rules={[{ required: true, message: "This field is required" }]}
                        validateTrigger={["onChange", "onBlur"]}
                      >
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="lastName">
                      <Form.Item
                        name="lastName"
                        label={formatMessage({ id: "last_name" })}
                        labelAlign="left"
                        labelCol={{ sm: 24 }}
                        rules={[{ required: true, message: "This field is required" }]}
                        validateTrigger={["onChange", "onBlur"]}
                      >
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="alternativeEmail">
                      <Form.Item name="alternativeEmail" label={formatMessage({ id: "alternative_email" })} labelAlign="left" labelCol={{ sm: 24 }}>
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="contactPhone">
                      <Form.Item name="contactPhone" label={formatMessage({ id: "contact_phone" })} labelAlign="left" labelCol={{ sm: 24 }}>
                        <Input
                          placeholder="E.g:13388886666"
                          addonBefore={contactPhonePrefixSelector}
                          autoComplete="off"
                          onChange={handle_modify_basic}
                          disabled={!can_edit_user || state.username === user_info.userName}
                        />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="industry">
                      <Form.Item name="industry" label={formatMessage({ id: "industry" })} labelAlign="left" labelCol={{ sm: 24 }}>
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="country">
                      <Row gutter={COL_SPACES}>
                        <Col span={12}>
                          <Form.Item
                            name="country"
                            label={formatMessage({ id: "country_region" })}
                            labelAlign="left"
                            labelCol={{ sm: 24 }}
                          // rules={[{ required: true, message: "This field is required" }]}
                          // validateTrigger={["onChange", "onBlur"]}
                          >
                            <Select
                              showSearch
                              placeholder={formatMessage({ id: "p_s_rc" })}
                              optionFilterProp="children"
                              onChange={handle_country_change}
                              disabled={!can_edit_user || state.username === user_info.userName}
                            >
                              {region_options}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="city" label={formatMessage({ id: "city" })} labelAlign="left" labelCol={{ sm: 24 }}>
                            <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Col>,
                    <Col span={8} key="company">
                      <Form.Item
                        name="company"
                        label={formatMessage({ id: "company" })}
                        labelAlign="left"
                        labelCol={{ sm: 24 }}
                      // rules={[{ required: true, message: "This field is required" }]}
                      // validateTrigger={["onChange", "onBlur"]}
                      >
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                    <Col span={8} key="address">
                      <Form.Item name="address" label={formatMessage({ id: "address" })} labelAlign="left" labelCol={{ sm: 24 }}>
                        <Input autoComplete="off" onChange={handle_modify_basic} disabled={!can_edit_user || state.username === user_info.userName} />
                      </Form.Item>
                    </Col>,
                  ]}
                  {(is_edit || is_invite) && (
                    <Col span={is_invite ? 12 : 8}>
                      <Form.Item name="userId" label={formatMessage({ id: "id" })} labelAlign="left" labelCol={{ sm: 24 }}>
                        <Input readOnly></Input>
                      </Form.Item>
                    </Col>
                  )}
                </Row>
              </Collapse.Panel>
              {search !== "addGroup" && (
                <Collapse.Panel
                  key="2"
                  header={
                    <span className="font-w-6">
                      <FormattedMessage id="resources_permission_mgmt" />
                    </span>
                  }
                  className="user_edit_collapse"
                >
                  {
                   !(user_info.is_namespacedeveloper) && <Row gutter={COL_SPACES}>
                      <Col sm={5}>
                        <Form.Item name="role" label={formatMessage({ id: "role" })} labelAlign="left" labelCol={{ sm: 24 }}>
                          <Select showSearch placeholder={formatMessage({ id: "select_role" })} optionFilterProp="children" onChange={handle_role_change} loading={loading_r}>
                            {parseSelect(role_select)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={5}>
                        <Form.Item name="cluster" label={formatMessage({ id: "cluster" })} labelAlign="left" labelCol={{ sm: 24 }}>
                          <Select
                            showSearch
                            placeholder={formatMessage({ id: "select_cluster" })}
                            optionFilterProp="children"
                            onChange={handle_cluster_change}
                            disabled={disable_c}
                            loading={loading_c}
                          >
                            {parseSelect(cluster_select)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={5}>
                        <Form.Item name="workspace" label={formatMessage({ id: "workspace" })} labelAlign="left" labelCol={{ sm: 24 }}>
                          <Select
                            showSearch
                            placeholder={formatMessage({ id: "select_ws" })}
                            optionFilterProp="children"
                            onChange={handle_workspace_change}
                            disabled={disable_w}
                            loading={loading_w}
                          >
                            {parseSelect(workspaces_select)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={5}>
                        <Form.Item name="namespace" label={formatMessage({ id: "namespace" })} labelAlign="left" labelCol={{ sm: 24 }}>
                          <Select
                            showSearch
                            placeholder={formatMessage({ id: "select_ns" })}
                            optionFilterProp="children"
                            onChange={handle_namespace_change}
                            disabled={disable_n}
                            loading={loading_n}
                          >
                            {parseSelect(namespaces_select)}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col sm={4}>
                        <Row align="bottom" justify="center" className="mt-20">
                          <Button
                            className="plain_button create_button"
                            size="large"
                            type="primary"
                            disabled={disable_add_role_button}
                            onClick={add_role_in_page}
                          >
                            <PlusOutlined />
                          </Button>
                          <Button
                            className="ml-20 plain_button create_button has_border"
                            size="large"
                            disabled={disable_del_role_button}
                            onClick={handle_del_limit}
                          >
                            <DeleteOutlined />
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  }
                  <Row className="small_table management-table w-100 mt-10">
                    <Table
                      size="small"
                      className="ant-col-sm-24"
                      rowClassName={() => "font-w-5"}
                      rowSelection={can_rolebinding ? rowSelection.current : undefined}
                      columns={roles_columns}
                      dataSource={roles_data}
                      showSorterTooltip={false}
                    />
                  </Row>
                </Collapse.Panel>
              )}
            </Collapse>
            {
              !(user_info.is_namespacedeveloper) ? <Row className="mt-20" gutter={40}>
                <Col span={12} className="text-right">
                  <Button type="primary" size="large" loading={is_save_ing} disabled={invalid} onClick={handle_add_profile}>
                    <FormattedMessage id="save"></FormattedMessage>
                  </Button>
                </Col>
                <Col span={12} className="text-left">
                  <Button onClick={handle_cancel} size="large">
                    <FormattedMessage id="cancel"></FormattedMessage>
                  </Button>
                </Col>
              </Row> : 
              <Row className="mt-20" gutter={40}>
                <Col span={24} className="text-center">
                  <Button onClick={handle_cancel} size="large">
                    <FormattedMessage id="cancel"></FormattedMessage>
                  </Button>
                </Col>
              </Row>
            }
          </Form>
        </Col>
      </Card>
      <Modal title={formatMessage({ id: "confirm" })} visible={delete_role_visible} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
        <p>{delete_row_word}</p>
      </Modal>
      <Modal title={formatMessage({ id: "confirm" })} visible={disable_user_modal_visible} onOk={handle_disable_user} onCancel={handle_disable_cancel}>
        <p>{disable_user_word}</p>
      </Modal>
      <Modal
        title={formatMessage({ id: "confirm" })}
        visible={save_role_modal_visible}
        onOk={handle_goto_save_role}
        onCancel={handle_giveup_save_role}
        okText={formatMessage({ id: "ok" })}
        cancelText={formatMessage({ id: "skip" })}
      >
        <p>
          <FormattedMessage id="role_not_insert"></FormattedMessage>
        </p>
      </Modal>
      <Modal
        title={formatMessage({ id: "invite" })}
        visible={invite_user_modal_visible}
        onOk={handle_invite_user_ok}
        onCancel={handle_invite_user_cancel}
        okText={formatMessage({ id: "confirm" })}
        cancelText={formatMessage({ id: "cancel" })}
      >
        <p>
          <FormattedMessage id="invite_user"></FormattedMessage>
        </p>
      </Modal>
    </Fragment>
  );
});
